import { observer } from "mobx-react-lite";
import { usePlayground } from "../../playground-store";

const DetectedInputVariables = () => {
  const { detectedInputVariables, template_format } = usePlayground();

  if (!detectedInputVariables.length) return null;

  const braceCount = template_format === "jinja2" ? 2 : 1;
  const startBrace = "{".repeat(braceCount);
  const endBrace = "}".repeat(braceCount);

  return (
    <div className="flex w-full flex-row items-center gap-2 overflow-x-auto overflow-y-hidden p-2">
      {detectedInputVariables.map((variable) => (
        <span key={variable} className="input-variable whitespace-nowrap">
          {`${startBrace}${variable}${endBrace}`}
        </span>
      ))}
    </div>
  );
};

export default observer(DetectedInputVariables);
